export const fmt = {
  currency: (val, currency = 'MXN') =>
    new Intl.NumberFormat('es-MX', { style: 'currency', currency }).format(val || 0),

  date: (val) => val ? new Date(val).toLocaleDateString('es-MX', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '-',

  dateTime: (val) => val ? new Date(val).toLocaleString('es-MX', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '-',

  shortDate: (val) => val ? new Date(val).toLocaleDateString('es-MX', { day: '2-digit', month: 'short' }) : '-'
};

export const STATUS_COLORS = {
  // Quotes
  borrador: 'default',
  enviada: 'info',
  aceptada: 'success',
  rechazada: 'error',
  facturada: 'secondary',
  cancelada: 'error',
  // Invoices
  parcial: 'warning',
  pagada: 'success',
  vencida: 'error',
  // Clients
  prospecto: 'info',
  activo: 'success',
  inactivo: 'default',
  vip: 'warning',
  // Payments
  aplicado: 'success',
};

export const STATUS_LABELS = {
  borrador: 'Borrador', enviada: 'Enviada', aceptada: 'Aceptada',
  rechazada: 'Rechazada', facturada: 'Facturada', cancelada: 'Cancelada',
  parcial: 'Parcial', pagada: 'Pagada', vencida: 'Vencida',
  prospecto: 'Prospecto', activo: 'Activo', inactivo: 'Inactivo', vip: 'VIP',
  aplicado: 'Aplicado',
};

export const PAYMENT_METHODS = {
  efectivo: 'Efectivo',
  transferencia: 'Transferencia',
  cheque: 'Cheque',
  tarjeta_credito: 'T. Crédito',
  tarjeta_debito: 'T. Débito',
  otro: 'Otro'
};
